import React from 'react';
import PropTypes from 'prop-types';
import styles from '../NumericField/NumericField.module.css';
import { useNumericFieldLogic } from './NumericFieldLogic';
import InfoTooltip from '../../shared/InfoTooltip/InfoTooltip';


const NumericField = ({
  id,
  label,
  value,
  onChange,
  min,
  max,
  step = "1",
  readOnly = false,
  required = false,
  currency = false,
  percentage = false,
  placeholder = "",
  tooltip = "",
  disabled = false
}) => {
  const {
    inputRef,
    displayValue,
    handleDigitsInput,
    handleStandardInput,
    handleBlur,
    setIsEditing
  } = useNumericFieldLogic({
    id,
    value,
    onChange,
    readOnly,
    currency,
    percentage,
    min,
    max
  });

  // Componente de rótulo com tooltip, se especificado
  const renderLabelWithTooltip = () => (
    <div className={styles.labelContainer}>
      <label htmlFor={id}>{label}{required && '*'}</label>
      <InfoTooltip text={tooltip} />
    </div>
  );

  if (currency || percentage) {
    const fieldClassName = currency ? styles.currencyField : styles.percentageField;
    const formatType = currency ? "currency" : "percentage";

    return (
      <div className={styles.formGroup}>
        {renderLabelWithTooltip()}
        <input
          ref={inputRef}
          type="text"
          id={id}
          className={`${styles.formControl} ${readOnly ? styles.readonlyField : ''} ${fieldClassName}`}
          value={displayValue}
          onChange={handleDigitsInput}
          onBlur={handleBlur}
          onFocus={() => {
            setIsEditing(true);
            if (!readOnly && inputRef.current) {
              inputRef.current.select();
            }
          }}
          placeholder={placeholder}
          readOnly={readOnly}
          required={required}
          data-format-type={formatType}
          disabled={disabled}
        />
      </div>
    );
  }

  // Campo numérico padrão
  return (
    <div className={styles.formGroup}>
      {renderLabelWithTooltip()}
      <input
        type="number"
        id={id}
        className={`${styles.formControl} ${readOnly ? styles.readonlyField : ''}`}
        value={value}
        onChange={handleStandardInput}
        min={min}
        max={max}
        step={step}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        disabled={disabled}
      />
    </div>  );
};

NumericField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  currency: PropTypes.bool,
  percentage: PropTypes.bool,
  placeholder: PropTypes.string,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool
};

NumericField.defaultProps = {
  step: "1",
  readOnly: false,
  required: false,
  currency: false,
  percentage: false,
  placeholder: "",
  tooltip: "",
  disabled: false
  // value removido dos defaultProps pois agora é obrigatório
};

export default NumericField;